import { render, staticRenderFns } from "./remark.modal.vue?vue&type=template&id=198dcba4&"
import script from "./remark.modal.vue?vue&type=script&lang=js&"
export * from "./remark.modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports